export default {
  english: {
    label: 'Language menu',
    en: 'English',
    fr: 'Français',
    ar: 'عربى',
    he: 'עברית',
    fa: 'فارسی',
  },
  french: {
    label: 'Menu de langue',
    en: 'English',
    fr: 'Français',
    ar: 'عربى',
    he: 'עברית',
    fa: 'فارسی',
  },
  arabic: {
    label: 'قائمة اللغة',
    en: 'English',
    fr: 'Français',
    ar: 'عربى',
    he: 'עברית',
    fa: 'فارسی',
  },
  hebrew: {
    label: 'תפריט שפה',
    en: 'English',
    fr: 'Français',
    ar: 'عربى',
    he: 'עברית',
    fa: 'فارسی',
  },
  persian: {
    label: 'منوی زبان',
    en: 'English',
    fr: 'Français',
    ar: 'عربى',
    he: 'עברית',
    fa: 'فارسی',
  },
}
